import React, {useState, useEffect} from 'react';
import {
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from 'reactstrap';
import Select from 'react-select';
import { get, merge, reduce, pickBy, startsWith, map } from 'lodash';

export const ASSIGNED_STATUS_FILTERS = [
  {'value': 20,'text': 'Allocated' },
  {'value': 25,'text': 'Accepted' },
  {'value': 26,'text': 'Referred Back To Radius'},
  {'value': 30,'text': 'Pending - Need to contact Customer' },
  {'value': 31,'text': 'Pending - Awaiting Customer Response' },
  {'value': 40,'text': 'Installation Booked' },
  {'value': 41,'text': 'Service Call Booked'},
  {'value': 76,'text': 'De & Re Booked' },
  {'value': 78,'text': 'De-Install Booked' },
  {'value': 50,'text': 'Not Complete [Engineer/Radius]'},
  {'value': 51,'text': 'No Show [Customer]' },
  {'value': 52,'text': 'Service Call Not Completed'},
]

export const COMPLETED_STATUS_FILTERS = [  
  {'value': 70,'text': 'Installation Completed' },
  {'value': 71,'text': 'Service Call Complete' },
  {'value': 77,'text': 'De & Re Completed' },
  {'value': 79,'text': 'De-Install Completed' },
  {'value': 80,'text': 'Job Not Required' },
]

export const ALL_STATUS_FILTERS = [
  {'value': 10,'text': 'Pending Allocation' },
  {'value': 20,'text': 'Allocated' },
  {'value': 25,'text': 'Accepted' },
  {'value': 26,'text': 'Referred Back To Radius'},
  {'value': 30,'text': 'Pending - Need to contact Customer' },
  {'value': 31,'text': 'Pending - Awaiting Customer Response' },
  {'value': 40,'text': 'Installation Booked' },
  {'value': 41,'text': 'Service Call Booked'},
  {'value': 50,'text': 'Not Complete [Engineer/Radius]'},
  {'value': 51,'text': 'No Show [Customer]' },
  {'value': 52,'text': 'Service Call Not Completed'},
  {'value': 70,'text': 'Installation Completed' },
  {'value': 71,'text': 'Service Call Complete' },
  {'value': 76,'text': 'De & Re Booked' },
  {'value': 77,'text': 'De & Re Completed' },
  {'value': 78,'text': 'De-Install Booked' },  
  {'value': 79,'text': 'De-Install Completed' },
  {'value': 80,'text': 'Job Not Required' },
]

export const SortList = ({
  options = [
    [ "Customer Name", "company_name" ]
  , [ "Order Ref", "order_ref" ]
  , [ "Surrogate ID", "customer_surrogate_id" ]
  , [ "Post Code", "postcode"]
  , [ "Town/City", "city" ]
  , [ "Country", "country" ]
  , [ "Job Type", "job_type" ]
  , [ "Created Date", "imported_at" ]
  ]
, filters
, setFilters
}) => {
  const asc = 'Ascending';
  const desc = 'Descending';

  const [option, setOption] = useState(options[options.length - 1]);
  const [order, setOrder] = useState(desc);

  useEffect(() => {
    console.log("set filters in SortList");
    setFilters({
      ...filters,
      ordering: order == asc ? option[1] : '-' + option[1],
    });
  }, [option, order])

  return (
    <label className="bd-highlight flex-wrap d-flex">
      <div className="mt-auto mb-auto">Sort By:</div>
      <UncontrolledDropdown  className="ml-2">
        <DropdownToggle caret color="gray" className="border border-secondary">
            {option != null ? option[0] : 'Sort by' }
        </DropdownToggle>
        <DropdownMenu right>
          {options.map((option, index) => (
            <DropdownItem key={`dropdown_item_${index}`} onClick={() => {setOption(option)}}>
              {option[0]}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
      <Button
        className="ml-2"
        color="gray"
        onClick={() => {
          order == asc ? setOrder(desc) : setOrder(asc);
        }}
      >
        {order}
      </Button>
    </label>
  )
}

  /*, [ "Job Type", "job_type" ]
  , [ "Job Make", "jobs__make" ]
  , [ "County", "county" ]
  */
export const JobTypeFilterList = ({
  options = [
    ["All",999]
  , ["New Installation",10]
  , ["New Installation + Remove Competitor Devices",80]
  , ["De-installation",20]
  , ["De-installation / Re-installation",30]
  , ["Service Call",40]
  ]
, filters
, setFilters
}) => {
  const [option, setOption] = useState(options[0]);

  useEffect(() => {
    console.log("set filters in JobTypeFilterList");
    setFilters({
      ...filters,
      jobtype_filter: option[1],
    });
  }, [option])

  return (
    <label className="bd-highlight flex-wrap d-flex">
      <div className="mt-auto mb-auto">Job Type:</div>
      <UncontrolledDropdown  className="mt-auto mb-auto ml-2">
        <DropdownToggle caret color="gray" className="border border-secondary">
        {option != null ? option[0] : 'Select Job Type' }
        </DropdownToggle>
        <DropdownMenu right>
          {options.map((option, index) => (
            <DropdownItem key={`dropdown_item_${index}`} onClick={() => {setOption(option)}}>
              {option[0]}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </label>
  )
}

export const SearchFilterList = ({
  options = [
    [ "Order Ref", "order_ref" ]
  , [ "Customer Name", "company_name" ]
  , [ "Surrogate ID", "customer_surrogate_id" ]
  , [ "Post Code", "postcode"]
  , [ "Town/City", "city" ]
  , [ "Country", "country" ]
  , [ "Job Number", "jobs__id" ]
  , [ "Job IMEI", "jobs__imei" ]
  , [ "Job Vehicle Reg", "jobs__vehicle_registration" ]
  ]
, filters
, setFilters
}) => {
  const [option, setOption] = useState(options[0]);

  useEffect(() => {
    console.log("set filters in SearchFilterList");
    setFilters({
      ...filters,
      search_filter: option[1],
    });
  }, [option])

  return (
    <label className="d-flex align-items-center p-1">
      <div className="mr-2">Filter By:</div>
      <UncontrolledDropdown>
        <DropdownToggle caret color="gray" className="border border-secondary">
          {option != null ? option[0] : 'Filter By' }
        </DropdownToggle>
        <DropdownMenu right>
          {options.map((option, index) => (
            <DropdownItem key={`dropdown_item_${index}`} onClick={() => {setOption(option)}}>
              {option[0]}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </label>
  )
}
export const WhiteLabelFilterList = ({
  options
, filters
, setFilters
}) => {
  const [option, setOption] = useState(null);

  useEffect(() => {
    console.log("set filters in WhiteLabelFilterList");
    setFilters({
      ...filters,
      wlp_filter: option == null ? '' : option.id ,
    });
  }, [option])

  return (
    <label className="bd-highlight flex-wrap d-flex">
      <div className="mt-auto mb-auto mr-2">White Label Partner:</div>
      <UncontrolledDropdown>
        <DropdownToggle caret color="gray" className="border border-secondary">
        {option != null ? option.name : 'Select Partner' }
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => {setOption(null)}}>
            All
          </DropdownItem>
          {options.map((option, index) => (
            <DropdownItem key={`dropdown_item_${index}`} onClick={() => {setOption(option)}}>
              {option.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </label>
  )
}

export const InstallationPartnerFilterList = ({
  options
, filters
, setFilters
, hideTag = false
}) => {
  const [option, setOption] = useState(null);

  useEffect(() => {
    console.log("set filters in InstallationPartnerFilterList");
    setFilters({
      ...filters,
      installer_filter: option == null ? '' : option.id ,
    });
  }, [option])

  return (
    <label className="bd-highlight flex-wrap d-flex">
      {!hideTag && <div className="mt-auto mb-auto mr-2">Install Partner:</div> }
      <UncontrolledDropdown>
        <DropdownToggle caret color="gray" className="border border-secondary">
          {option != null ? option.name : <span className='text-muted'>All</span> }
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => {setOption(null)}}>
            All
          </DropdownItem>
          {options.map(option => (
            <DropdownItem onClick={() => {setOption(option)}}>
              {option.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </label>
  )
}

export const JobSubStatusFilter = ({
  options
, filters
, setFilters
, hideTag = false
}) => {

  const [statuses, setStatuses ] = useState(null);

  // update filters if statuses change
  useEffect(() => {
    if (statuses != null) {
      const arrStats = statuses.map((x,y) => {
        const key = "status" + y;
        return {[key]: x.value}
      });

      const statFilters =  reduce(
        arrStats,
        (acc, i) => merge(acc, i), {}
      );

      const filterSansStats = pickBy(
        filters,
        (val,key) => !key.startsWith("status")
      );

      console.log("set filters in JobSubStatusFilter");
      setFilters({
        ...filterSansStats,
        ...statFilters
      });
    }
  }, [statuses]);

  return (
    <label className="bd-highlight flex-wrap d-flex">
      {!hideTag && <div className="mt-auto mb-auto">Job Statuses:</div> }
      <Select
        style={{
          borderColor:  '#6c757d',
          width: '400px',
          overflow: 'visible',
        }}
        options={options}
        onChange={setStatuses}
        value={statuses}
        className='ml-2 basic-multi-select'
        labelKey="text"
        valueKey="value"
        multi
      />
    </label>
  )
}

export const JobSubSubStatusFilter = ({
  options,
  filters,
  setFilters,
  hideTag = false
}) => {

  const [subStatuses, setSubStatuses ] = useState(null);

  useEffect(() => {
    if (subStatuses != null) {
      const arrStats = subStatuses.map((x,y) => {
        const key = "substatus" + y;
        return {[key]: x.value}
      });

      const statFilters =  reduce(
        arrStats,
        (acc, i) => merge(acc, i), {}
      );

      const filterSansStats = pickBy(
        filters,
        (val,key) => !key.startsWith("substatus")
      );

      console.log("set filters in JobSubStatusFilter");
      setFilters({
        ...filterSansStats,
        ...statFilters
      });
    }
  }, [subStatuses]);

  return (
    <label className="bd-highlight flex-wrap d-flex">
      {!hideTag && <div className="mt-auto mb-auto">Job Status Detail:</div> }
      <Select
        style={{
          borderColor:  '#6c757d',
          width: '350px',
          overflow: 'visible',
        }}
        options={options}
        onChange={setSubStatuses}
        value={subStatuses}
        className='ml-2 basic-multi-select'
        labelKey="text"
        valueKey="value"
        multi
      />
    </label>
  )
}


// WEBPACK FOOTER //
// ./src/components/common/Tables/ListFilters.jsx